import React, { useState, useRef, useEffect } from 'react';

interface SettingDialogProps {
    open: boolean;
    onClose: () => any;
}
const SettingDialog: React.FC<SettingDialogProps> = props => {

    return <g>
        {/* <g><rect fill="green" x="50" width="200" y="50" height="200"></rect></g> */}
    </g>
}

export default SettingDialog;